export class AddressDetailsModel {

    public permanent: AddressModel;
    public correspondence: AddressModel;
    public note: NoteModel;

    constructor(obj?: any) {
        this.permanent      = obj && new AddressModel(obj.permanent)        || new AddressModel();
        this.correspondence = obj && new AddressModel(obj.correspondence)   || new AddressModel();
        this.note           = obj && new NoteModel(obj.note)                || new NoteModel();
    }
}

export class AddressModel {

    public id: number;
    public apt: string;
    public building: string;
    public city: string;
    public cityTypeId: number;
    public countryId: number;
    public district: string;
    public house: string;
    public region: string;
    public soatoCode: string;
    public street: string;
    public streetTypeId: number;
    public unitaryArea: string;
    public zip: number;

    constructor(obj?: any) {
        this.id             = obj && obj.id             || null;
        this.apt            = obj && obj.apt            || '';
        this.building       = obj && obj.building       || '';
        this.city           = obj && obj.city           || '';
        this.cityTypeId     = obj && obj.cityTypeId     || null;
        this.countryId      = obj && obj.countryId      || null;
        this.district       = obj && obj.district       || '';
        this.house          = obj && obj.house          || '';
        this.region         = obj && obj.region         || '';
        this.soatoCode      = obj && obj.soatoCode      || '';
        this.street         = obj && obj.street         || '';
        this.streetTypeId   = obj && obj.streetTypeId   || '';
        this.unitaryArea    = obj && obj.unitaryArea    || '';
        this.zip            = obj && obj.zip            || '';
    }
}

export class NoteModel {

    public id: number;
    public note: string;
    public noteUpdatedBy: string;

    constructor(obj?: any) {
        this.id             = obj && obj.id             || null;
        this.note           = obj && obj.note           || '';
        this.noteUpdatedBy  = obj && obj.noteUpdatedBy  || '';
    }

}



// WEBPACK FOOTER //
// ./src/app/models/address-details.model.ts